// app/src/pages/ProSignUpPage.tsx
import React, { FC, useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useAuthContext } from '../contexts/AuthContext';
import HeaderDesktopPro from "../components/desktop/pro/HeaderDesktopPro";
import HeaderMobilePro from "../components/mobile/pro/HeaderMobilePro";
import HeaderLaptopPro from "../components/laptop/pro/HeaderLaptopPro";
import { useTranslation } from 'react-i18next';

import { CircularProgress } from "@mui/material";
import SignUpPageDesktopPro
	from "../components/desktop/pro/SignUpPageDesktopPro";
import SignUpPageMobilePro from "../components/mobile/pro/SignUpPageMobilePro";
import SignUpPageLaptopPro from "../components/laptop/pro/SignUpPageLaptopPro";
import { emitAnalytics, getTelemetryDeviceType } from '../services/telemetry/appInsights';



const ProSignUpPage: FC = () => {
	const { i18n } = useTranslation();
	const { loadingSignup, handleSignUpPro } = useAuthContext();
	const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
	const isDesktop = useMediaQuery({ query: '(min-width: 1660px)' });
	const hasTrackedSignupStart = useRef(false);

	useEffect(() => {
		if (hasTrackedSignupStart.current) {
			return;
		}

		hasTrackedSignupStart.current = true;
		emitAnalytics('pro_signup_started', {
			entryRoute: '/pro/signup',
			deviceType: getTelemetryDeviceType(),
			language: i18n.language,
		});
	}, []);
	
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'start',
				alignItems: 'center',
			}}
		>
			{loadingSignup &&
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(255, 255, 255, 0.8)',
						backdropFilter: 'blur(3px)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 10,
					}}
				>
					<CircularProgress />
				</div>
			}
			{isDesktop ? (
				<>
					<HeaderDesktopPro />
					<SignUpPageDesktopPro />
				</>)
				: isMobile ? (
				<>
					<HeaderMobilePro />
					<SignUpPageMobilePro />
				</>)
			:(
				<>
					<HeaderLaptopPro />
					<SignUpPageLaptopPro />
				</>)
				}
		</div>
	);
};

export default ProSignUpPage;
